module.exports = "<div class=\"form-group row\">\r\n    <ixs-label label=\"{{label}}\"></ixs-label>\r\n    <div class=\"col-md-9\">\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"value\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/textbox/textbox.component.html
// module id = 1219
// module chunks = 320